<template>
  <b-modal :id="modalId" :title="title" @show="setupModal" size="lg" no-close-on-backdrop>
    <div class="row" v-if="setupComplete">
      <div class="col-12" v-if="!isDeleting">
        <select-filter
          v-for="(filter, index) in filters"
          :key="index"
          :index="index"
          :filter="filter"
          :filterTypes="filterTypes"
          :preSelectedFilters="filters"
          @selectedFilter="updateFilter"
          @deleteFilter="deleteFilter" />
      </div>
    </div>
    <div class="row">
      <div class="offset-11 col-1">
        <button class="btn btn-sm btn-info" @click="addNewFilter"><font-awesome-icon icon="plus" /></button>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button @click="hideFilterModal" class="btn">Cancel</button>
      <button class="btn btn-info"
        @click="filterItems">
        Filter
      </button>
    </template>
  </b-modal>
</template>

<script>
import SelectFilter from '../Inputs/SelectFilter';
import config from '../../constants/config';

export default {
  name: 'FilterModal',
  components: {
    SelectFilter
  },
  props: {
    filterTypes: Array,
    itemName: String,
    initialFilter: Array,
    title: String
  },
  data() {
    return {
      filters: [],
      isDeleting: false,
      daysAgoAPIKeys: {},
      daysAgoKeys: [],
      beforeAfterKeys: [],
      setupComplete: false
    };
  },
  created() {
    // set up date time keys which have to be handled differently
    this.daysAgoAPIKeys[config.CREATED_IN] = config.CREATED_AFTER;
    this.daysAgoKeys = Object.keys(this.daysAgoAPIKeys);
    this.beforeAfterKeys = [
      config.CREATED_BEFORE,
      config.CREATED_AFTER
    ];
  },
  methods: {
    setupModal() {
      this.setupComplete = false;
      this.filters = this.initialFilter;

      if (!this.filters) {
        this.filters = [];
        this.addNewFilter();
      }

      this.setupComplete = true;
    },
    addNewFilter() {
      this.filters.push({});
    },
    updateFilter({ index, selection }) {
      this.filters[index] = selection;
    },
    deleteFilter(index) {
      this.isDeleting = true;
      this.filters = this.filters.filter((_filter, i) => {
        return index != i;
      });

      // force re-render of list
      this.$nextTick(() => {
        this.isDeleting = false;
      });
    },
    filterItems() {
      let formattedFilter = {};
      this.filters.forEach(element => {
        if (element.selectedValue) {
          formattedFilter[this.getApiParamName(element)] = this.getApiParamValue(element);
        }
      });

      this.$emit('filterItems', { filterConfig: this.filters, apiFilters: formattedFilter });
      this.hideFilterModal();
    },
    getApiParamName(item) {
      if (this.daysAgoKeys.includes(item.subFilterKey)) {
        return this.daysAgoAPIKeys[item.subFilterKey];
      }
      return item.subFilterKey;
    },
    getApiParamValue(item) {
      if (this.daysAgoKeys.includes(item.subFilterKey)) {
        return this.calculateDaysAgo(item.selectedValue);
      } else if (this.beforeAfterKeys.includes(item.subFilterKey)) {
        return new Date(item.selectedValue).toISOString();
      }
      return item.selectedValue;
    },
    hideFilterModal() {
      this.$bvModal.hide(this.modalId);
    },
    calculateDaysAgo(daysAgo) {
      let d = new Date();
      d.setDate(d.getDate() - daysAgo);
      return d.toISOString();
    },
    findFilter(subFilterKey) {
      return this.filterTypes.find(filter => {
        let subKeys = filter.subFilters.map(item => item.key);
        return subKeys.includes(subFilterKey);
      })
    }
  },
  computed: {
    modalId() {
      return config.FILTER_MODAL_ID;
    }
  }
};
</script>
